import key from '../config/config';
import * as api from "../routes/userroutefront";
import axios, { setAuthorization } from "../config/axios";
import { setAccountData } from "./userlogin"

export const enable2faCode = async (data, dispatch) => {
    try {
        let respData = await axios({
            'url': key.API_URL + api.enable2fa,
            'method': 'post',
            'data': data
        });
        dispatch(setAccountData(respData?.data?.result))

        return {
            status: respData?.data?.status,
            message: respData?.data?.message,
            result: respData?.data?.result
        }
    }
    catch (err) {
        // console.log(err, 'enable2faCode_error')
        return {
            status: err?.response?.data?.status,
            message: err?.response?.data?.message,
            error: err?.response?.data?.errors
        }
    }
}

export const disable2faCode = async (data, dispatch) => {
    try {
        let respData = await axios({                                                                
            'url': key.API_URL + api.disable2fa,
            'method': 'post',
            'data': data
        });
        dispatch(setAccountData(respData?.data?.result))

        return {
            status: respData?.data?.status,
            message: respData?.data?.message,
            result: respData?.data?.result
        }
    }
    catch (err) {
        // console.log(err, 'disable2faCode_error')
        return {
            status: err?.response?.data?.status,
            message: err?.response?.data?.message,
            error: err?.response?.data?.errors
        }
    }
}

export const get2faCode = async (data, dispatch) => {
    try {
        let respData = await axios({
            'url': key.API_URL + api.get2fa,
            'method': 'get'
        });
        // dispatch(setAccountData(respData?.data?.result))

        return {
            status: respData?.data?.status,
            message: respData?.data?.message,
            result: respData?.data?.result
        }
    }
    catch (err) {
        // console.log(err, 'get2faCode_error')
        return {
            status: err?.response?.data?.status,
            message: err?.response?.data?.message,
            error: err?.response?.data?.errors
        }
    }
}